"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveAbVariantMutation = exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _notistack = require("notistack");

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _PageLoadingSpinner = _interopRequireDefault(require("@jobmatchme/ui/es/components/PageLoadingSpinner"));

var _translations = _interopRequireDefault(require("@jobmatchme/utils/es/translations"));

var _urlParamsHelper = _interopRequireDefault(require("@jobmatchme/routing/es/utils/urlParams/urlParamsHelper"));

var _Pc = require("@jobmatchme/amplify-tools/es/api/Pc");

var _Pc2 = require("@jobmatchme/amplify-tools/es/provider/Pc");

var _analytics = require("@jobmatchme/frontend-analytics/es/analytics");

var _ProfileProvider = require("@jobmatchme/profile-components/es/provider/ProfileProvider");

var _ConfigProvider = require("@jobmatchme/profile-components/es/provider/ConfigProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

//import {useAbTest} from '@jobmatchme/utils/es/ABTest'
var saveAbVariantMutation = "mutation SaveAbVariant($abVariant: AbVariantInput!) {\n  saveAbVariant(abVariant: $abVariant) {\n    success\n  }\n}\n"; // AB Test

exports.saveAbVariantMutation = saveAbVariantMutation;

var SaveProfileError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(SaveProfileError, _Error);

  var _super = _createSuper(SaveProfileError);

  function SaveProfileError(error, profileCommand) {
    var _this;

    (0, _classCallCheck2.default)(this, SaveProfileError);
    // Übergibt die verbleibenden Parameter (einschließlich Vendor spezifischer Parameter) dem Error Konstruktor
    _this = _super.call(this, error); // Behält den richtigen Stack-Trace für die Stelle bei, an der unser Fehler ausgelöst wurde (nur bei V8 verfügbar)

    _this.profileCommand = void 0;
    _this.date = void 0;

    if (Error.captureStackTrace) {
      Error.captureStackTrace((0, _assertThisInitialized2.default)(_this), SaveProfileError);
    } // Benutzerdefinierte Debugging Informationen


    _this.profileCommand = profileCommand;
    _this.date = new Date();
    return _this;
  }

  return (0, _createClass2.default)(SaveProfileError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

var reportToSentry = function reportToSentry(error, profile) {
  return Sentry.withScope(function (scope) {
    scope.setTag('log-location', 'Failed sending profile to service');
    scope.setTag('application', '@jobmatchme/profile-components');
    Sentry.captureException(new SaveProfileError(error, profile));
  });
};

var restSaveProfile = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(profile, config) {
    var abVariant,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            abVariant = _args.length > 2 && _args[2] !== undefined ? _args[2] : '';
            _context.t0 = _Pc.PcApi;
            _context.t1 = profile;
            _context.next = 5;
            return _Pc.PcApi.authHeader();

          case 5:
            _context.t2 = _context.sent;
            _context.t3 = {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: _context.t2
            };
            return _context.abrupt("return", _context.t0.post.call(_context.t0, '/pcProfileService/rest/user/createWithProfile', _context.t1, _context.t3).then(function () {
              (0, _analytics.trackRegistration)("arbeitnehmer-".concat(config.discriminator));
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function restSaveProfile(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var restUpdateProfile = function restUpdateProfile(profile) {
  return _Pc.PcApi.post('/pcProfileService/rest/user/profile/edit', profile);
};

var saveUrlParams = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var urlParams, isControl, storageData;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // urlParmams with 'control' should be removed.
            // For correct login via FaceBook and Google
            try {
              urlParams = {};
              urlParams = (JSON.parse(localStorage.getItem('urlParams') || '') || {}).params;
              isControl = urlParams.control ? urlParams.control : false;

              if (isControl) {
                //Erase 'control' data
                delete urlParams.control;
                localStorage.removeItem('urlParams'); //Create new local storage without control

                localStorage.setItem('urlParams', JSON.stringify({
                  params: urlParams
                }));
              }
            } catch (error) {}

            storageData = localStorage.getItem('urlParams');

            if (!storageData) {
              _context2.next = 11;
              break;
            }

            _context2.t0 = _Pc.PcApi;
            _context2.t1 = JSON.parse(storageData).params;
            _context2.next = 7;
            return _Pc.PcApi.authHeader();

          case 7:
            _context2.t2 = _context2.sent;
            _context2.t3 = {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: _context2.t2
            };

            _context2.t0.post.call(_context2.t0, '/pcProfileService/rest/urlparams/edit', _context2.t1, _context2.t3);

            // Delete local storage data so that there is no re-recording
            // the next time the page is called
            new _urlParamsHelper.default().cleanupUrlParams();

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function saveUrlParams() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Component Wrapper for handling the storing of a profile
 * @param {React.Component} LoadingComponent  A component to show while saving the profile
 * @param {React.Component} RegistrationComponent  A Component to login or register, if no user is authenticated
 */
var StoreProfile = function StoreProfile(_ref3) {
  var Loader = _ref3.Loader,
      RegistrationComponent = _ref3.RegistrationComponent,
      targetPaths = _ref3.targetPaths,
      _ref3$onRegistration = _ref3.onRegistration,
      onRegistration = _ref3$onRegistration === void 0 ? function () {} : _ref3$onRegistration;
  var t = (0, _translations.default)('pc-funnel:funnel.StoreProfile');

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar; // Registration Context


  var registrationData = (0, _react.useContext)(_ProfileProvider.ProfileContext);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      cleanup = _useContext.cleanup,
      areAllFunnelsCompleted = _useContext.areAllFunnelsCompleted,
      getPlainProfile = _useContext.getPlainProfile;

  var _useContext2 = (0, _react.useContext)(_ConfigProvider.ConfigurationContext),
      config = _useContext2.config;

  var _useAmplifyUser = (0, _Pc2.useAmplifyUser)(),
      isAuthenticated = _useAmplifyUser.isAuthenticated,
      isLoading = _useAmplifyUser.isLoading,
      loadAuth = _useAmplifyUser.loadAuth,
      fetchUserData = _useAmplifyUser.fetchUserData;

  var shouldSkip = !isLoading && isAuthenticated && !sessionStorage.getItem('pc-profile-finished');

  var _useState = (0, _react.useState)(shouldSkip ? 'skip' : 'init'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      matchesNumber = _useState4[0],
      setMatchesNumber = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      matchesLoaded = _useState6[0],
      setMatchesLoaded = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      updatedRevision = _useState8[0],
      setUpdatedRevison = _useState8[1];

  var profile = (0, _react.useMemo)(function () {
    return (0, _extends2.default)({
      discriminator: (config || {}).discriminator
    }, getPlainProfile(1));
  }, [config, getPlainProfile]);
  var createProfileCommand = (0, _react.useMemo)(function () {
    return {
      discriminator: (config || {}).discriminator,
      profile: getPlainProfile(1)
    };
  }, [config, getPlainProfile]);
  var dataCanBeStored = !isLoading && isAuthenticated && status === 'init' && sessionStorage.getItem('pc-profile-finished') && (config || {}).registration && areAllFunnelsCompleted; // AB Test Code
  // Uncomment this code for running an A/B Test
  //const ABTEST_TAG = 'jmm334'
  //const abTest = useAbTest(ABTEST_TAG)
  //const abVariant = abTest.variant

  var saveProfile = (0, _react.useCallback)(function () {
    setStatus('saving');
    return restSaveProfile(createProfileCommand, config).catch(function (error) {
      // If response is 409, we want to update the profile
      if (error.response.status === 409) {
        return restUpdateProfile(createProfileCommand).then(function (response) {
          return setUpdatedRevison(response.newRevision);
        });
      } else throw error;
    }).then(saveUrlParams) // Uncomment this code for running an A/B Test

    /** 
    .then(() => {
      PcApi.graphql({
        query: saveAbVariantMutation,
        variables: {
          abVariant: {
            variant: (abVariant || '').toUpperCase(),
            tag: ABTEST_TAG
          }
        }
      })
    })*/
    ; //}, [abVariant, config, createProfileCommand])
  }, [config, createProfileCommand]); // If the user is logged in an has a finished profile, we attempt to save it

  (0, _react.useEffect)(function () {
    var registrationCompleteCallback = function registrationCompleteCallback(registrationData) {
      var updateCognitoAttributes = function updateCognitoAttributes() {
        var userAttributes = {};
        ((config || {}).registration || []).forEach(function (reg) {
          var attributes = reg.userAttributes;
          return Object.entries(attributes).forEach(function (_ref4) {
            var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
                key = _ref5[0],
                value = _ref5[1];

            userAttributes[key] = registrationData[value];
          });
        });
        return loadAuth().then(function (PcAuth) {
          return PcAuth.currentAuthenticatedUser().then(function (user) {
            PcAuth.updateUserAttributes(user, userAttributes).then(function () {
              return (// Update amplify state
                fetchUserData(true)
              );
            });
          });
        });
      };

      Promise.all([saveProfile(), updateCognitoAttributes()]).then(function () {
        // Cleanup right before redirect
        cleanup();
        sessionStorage.removeItem('pc-profile-finished');
        setStatus('done');

        if (onRegistration) {
          onRegistration();
        }
      }).catch(function (error) {
        reportToSentry(error, createProfileCommand);
        setStatus('error');
        enqueueSnackbar(t('error'), {
          persist: true,
          variant: 'error'
        });
      });
    };

    if (dataCanBeStored) {
      registrationCompleteCallback(getPlainProfile());
    }
  }, [config, createProfileCommand, enqueueSnackbar, registrationData, dataCanBeStored, saveProfile, t, onRegistration, cleanup, fetchUserData, getPlainProfile, loadAuth]); // If a user is logged in but no finished profile is present, make sure to redirekt him to the matching
  // This happens for example on oAuth login.

  (0, _react.useEffect)(function () {
    if (shouldSkip) {
      setStatus('skip');
    }
  }, [shouldSkip]);
  var discriminator = (config || {}).discriminator;
  var matchesLoadedCallback = (0, _react.useCallback)(function (matches) {
    // Set the number of fetched matches
    setMatchesNumber(matches.length); // Persist matches to session storage optimistically

    sessionStorage.setItem('optimistic-matches-' + discriminator, JSON.stringify(matches));
    setMatchesLoaded(true);
  }, [discriminator]);

  var getScreen = function getScreen() {
    switch (status) {
      case 'done':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Navigate, {
          to: targetPaths.onRegistration,
          state: {
            optimisticProfile: profile,
            newRevision: updatedRevision
          }
        });

      case 'skip':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Navigate, {
          to: targetPaths.onSkip
        });

      case 'error':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("h5", {
          children: t('message')
        });

      case 'saving':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PageLoadingSpinner.default, {
          fullHeight: true
        });
      // eslint-disable-next-line no-fallthrough

      default:
        //return abVariant === 'B' ? (
        //  RegistrationComponent && (
        //    <RegistrationComponent matchesNumber={matchesNumber} />
        //  )
        //) : Loader && !matchesLoaded ? (
        return Loader && !matchesLoaded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Loader, {
          preventDataFetching: ['saving', 'error'].includes(status) || dataCanBeStored || isLoading,
          optimisticProfile: profile,
          matchesLoadedCallback: matchesLoadedCallback
        }) : RegistrationComponent && /*#__PURE__*/(0, _jsxRuntime.jsx)(RegistrationComponent, {
          matchesNumber: matchesNumber
        });
    }
  };

  return getScreen();
};

var _default = /*#__PURE__*/(0, _react.memo)(StoreProfile);

exports.default = _default;